import { NgModule } from '@angular/core';
import { StartManualAutomationDialogComponent } from './start-manual-automation-dialog/start-manual-automation-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCommonModule, MatLineModule } from '@angular/material/core';
import { AutocompleteInfiniteScrollDirective } from './autocomplete-infinite-scroll.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { StartManualAutomationFormComponent } from './start-manual-automation-form/start-manual-automation-form.component';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatListModule } from '@angular/material/list';
import { InViewportModule } from 'ng-in-viewport';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';

@NgModule({
  declarations: [
    StartManualAutomationDialogComponent,
    AutocompleteInfiniteScrollDirective,
    StartManualAutomationFormComponent,
  ],
  exports: [StartManualAutomationFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatCommonModule,
    MatLineModule,
    MatIconModule,
    MatProgressSpinnerModule,
    GalaxySnackbarModule,
    MatDividerModule,
    GalaxyAlertModule,
    GalaxyWrapModule,
    MatListModule,
    InViewportModule,
    GalaxyTooltipModule,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    MatRadioModule,
    GalaxyInfiniteScrollTriggerModule,
  ],
})
export class StartManualAutomationModule {}
